import {createContext} from 'react';

export const TableRowContext = createContext({isHovered: false});
